import { Stack, Typography } from '@mui/material';

import { ResolutionType, ResolutionTypeCategory } from 'src/constants/ResolutionTypes';

interface ResolutionCategoryListProps {
    categories: ResolutionTypeCategory[];
    renderItem: (resolutionType: ResolutionType) => React.ReactNode;
    excludedResolutionTypes?: ResolutionType[];
}

const ResolutionCategoryList = ({
    categories,
    renderItem,
    excludedResolutionTypes = [],
}: ResolutionCategoryListProps) => {
    return (
        <Stack sx={{ gap: 4 }}>
            {categories.map(
                (category) =>
                    (category.subTypes || []).length > 0 && (
                        <Stack key={category.id} sx={{ gap: 1.5 }}>
                            {category.displayName && (
                                <Typography
                                    variant="subtitle1"
                                    component="h2"
                                    sx={{ textTransform: 'uppercase', fontWeight: 'bold' }}
                                >
                                    {category.displayName}
                                </Typography>
                            )}
                            <Stack sx={{ gap: 2.5 }}>
                                {category.subTypes!.map((resolutionType) =>
                                    !excludedResolutionTypes.includes(resolutionType)
                                        ? renderItem(resolutionType)
                                        : null
                                )}
                            </Stack>
                        </Stack>
                    )
            )}
        </Stack>
    );
};

export default ResolutionCategoryList;
